import * as Yup from "yup";
import { talentNotesInputMaxLength } from "./common";

export const TalentNotesSchema = Yup.object().shape({
  notes: Yup.string().max(talentNotesInputMaxLength.notes, "Please, make it shorter than 640 symbols"),
  type: Yup.string().max(talentNotesInputMaxLength.type, "Please, make it shorter than 50 symbols"),
});
